export default __webpack_public_path__ + "static/media/a037-9.f5fe456d.svg";